<script setup lang="ts">
  import DynamicVariableInput from '@/components/form/DynamicVariableInput.vue'
  import FlowPathInput from '@/components/form/FlowPathInput.vue'
  import {
    FormFieldContainer,
    InputField,
    type SetLocalStorageElement,
  } from '@logistiek-zonder-papier/lzp-library'
  import { reactive } from 'vue'

  const field = defineModel<SetLocalStorageElement>({ required: true })

  const touched = reactive({
    name: false,
    sourcePath: false,
    key: false,
  })

  function validateRequired(key: 'name' | 'sourcePath' | 'key', message: string) {
    return touched[key] && field.value?.type === 'setLocalStorage' && !field.value?.[key]?.trim()
      ? message
      : null
  }
</script>

<template>
  <div class="field-config-container">
    <FormFieldContainer label="Name" :error="validateRequired('name', 'Name is required')">
      <InputField
        placeholder="Set local storage name"
        hint="Identifier for this step, only visible in the portal."
        v-model="field.name"
        type="text"
        @blur="touched.name = true"
      />
    </FormFieldContainer>

    <DynamicVariableInput
      label="Source path"
      :error="validateRequired('sourcePath', 'Source path is required')"
      placeholder="path.to.value"
      hint="Value that is written to localStorage once this page is completed."
      v-model="field.sourcePath"
      type="text"
      @blur="touched.sourcePath = true"
      :optional="false"
      :validate-paths="true"
    />

    <FormFieldContainer
      label="localStorage key"
      :error="validateRequired('key', 'localStorage key is required')"
    >
      <FlowPathInput
        placeholder="e.g. driver-name"
        hint="Key that is (over)written. Supports ${...} interpolation."
        v-model="field.key"
        type="text"
        :optional="false"
        :validate-paths="true"
        @blur="touched.key = true"
      />
    </FormFieldContainer>
  </div>
</template>

<style scoped>
  .field-config-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
</style>
